// extracted by mini-css-extract-plugin
module.exports = {"assignBtn":"_2bW7bEwUUTIARWrr4LudN_","icon":"_1IC9yTUqU32mNB7cps_ZnE"};